import { CheckBoxItem } from '../util/checkBox';
import { EntryField } from '../util/common/entryField';
import { CheckInConfirmInfoCard } from './checkInConfirmCard';
import './checkInReserveConfirmStyle.css';
import { ReserveButtonField } from './reserveButtonField';

interface CheckInReserveConfirmProps {
  listItem: {
    reserveInfoList: Record<string, string>[];
    carConditionList: Record<string, string>[];
    loanerCarList: Record<string, string>[];
    checkInDateList: Record<string, string>[];
  };
  checkApprove: boolean;
  disabled: boolean;
  onChangeApprove: () => void;
  onEditCarCondition: () => void;
  onEditLoanerCar: () => void;
  onEditCheckInDate: () => void;
  onReserve: () => void;
}
export const CheckInReserveConfirm = ({
  listItem,
  checkApprove,
  disabled,
  onChangeApprove,
  onEditCarCondition,
  onEditLoanerCar,
  onEditCheckInDate,
  onReserve,
}: CheckInReserveConfirmProps) => {
  const { reserveInfoList, carConditionList, loanerCarList, checkInDateList } =
    listItem;
  const ApproveReserveField = () => {
    const noteText = [
      '緊急入庫対応等の工場稼働状況により、ご予約日当日にご入庫日の変更をご依頼する可能性もございます。',
      'お車をお預かりする際に車内の車検証などを確認させていただく場合がございます。',
    ];
    return (
      <div className={'loaner-car-approve'}>
        <div className={'check-in-reserve-approve-message'}>
          <ol type={'1'}>
            {noteText.map((text, idx) => (
              <li key={idx}>
                <span key={idx}>{text}</span>
              </li>
            ))}
          </ol>
        </div>
        <div className={'check-in-reserve-approve-check'}>
          <CheckBoxItem
            name={'check-in-reserve-approve-check'}
            onChange={onChangeApprove}
            check={checkApprove}
            label={'内容を確認し、承諾する'}
          />
        </div>
      </div>
    );
  };
  return (
    <div className={'check-in-reserve-confirm-field'}>
      <div className={'reserve-confirm-info-field'}>
        <CheckInConfirmInfoCard info={reserveInfoList ?? []} />
        <CheckInConfirmInfoCard
          info={carConditionList ?? []}
          header={{ label: 'お車の状態', onEdit: onEditCarCondition }}
        />
        <CheckInConfirmInfoCard
          info={loanerCarList ?? []}
          header={{ label: '代車の利用', onEdit: onEditLoanerCar }}
        />
        <CheckInConfirmInfoCard
          info={checkInDateList ?? []}
          header={{ label: '入庫日', onEdit: onEditCheckInDate }}
        />
        <EntryField label={'確認事項'} required={true}>
          <ApproveReserveField />
        </EntryField>
      </div>
      <ReserveButtonField disable={disabled} onClick={onReserve} />
    </div>
  );
};
